import { render, staticRenderFns } from "./ReCardServiceView.vue?vue&type=template&id=185fd169&scoped=true"
import script from "./ReCardServiceView.vue?vue&type=script&lang=js"
export * from "./ReCardServiceView.vue?vue&type=script&lang=js"
import style0 from "./ReCardServiceView.vue?vue&type=style&index=0&id=185fd169&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185fd169",
  null
  
)

export default component.exports